module.exports = __webpack_public_path__ + "static/media/TH.8a75868d.svg";